import request from './core/request'

// 浏览历史相关API
export default {
	//获取浏览历史记录
	getFootPrintList: (params) => request.get(`member/footprint`, params, {}),
}